export { default } from "./PsPricingV2Mspa";
